"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var react_window_1 = require("react-window");
var OptimizedMenuList = /** @class */ (function (_super) {
    __extends(OptimizedMenuList, _super);
    function OptimizedMenuList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.height = 40;
        return _this;
    }
    OptimizedMenuList.prototype.render = function () {
        var _a = this.props, options = _a.options, children = _a.children, maxHeight = _a.maxHeight, getValue = _a.getValue, selectProps = _a.selectProps;
        var selectedValues = Array.isArray(getValue())
            ? getValue()
            : [];
        var initialOffset = selectedValues.length > 0
            ? options.indexOf(selectedValues[0]) * this.height
            : 0;
        var childrenArray = React.Children.toArray(children);
        var showErrorMessage = React.Children.count(children) === 1 && childrenArray[0] === undefined;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_window_1.FixedSizeList, { height: showErrorMessage ? 0 : maxHeight, itemCount: childrenArray.length, itemSize: showErrorMessage ? 0 : this.height, initialScrollOffset: initialOffset, width: "", children: function (_a) {
                        var index = _a.index, style = _a.style;
                        return (0, jsx_runtime_1.jsx)("div", { className: "option-wrapper", style: style, children: childrenArray[index] });
                    } }), showErrorMessage && (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "text-red pl-4 pr-4 pb-2 pt-3", children: ["Sorry, we couldn't find any matches for \"", selectProps.inputValue, "\""] }), { /* @ts-ignore */}, selectProps.helpTextRow1 && (0, jsx_runtime_1.jsx)("div", { className: "pl-4 pr-4 pt-3 pb-2 help-text", children: selectProps.helpTextRow1 }), { /* @ts-ignore */}, selectProps.helpTextRow2 && (0, jsx_runtime_1.jsx)("div", { className: "pl-4 pr-4 pt-2 pb-3 help-text", children: selectProps.helpTextRow2 })] })] }));
    };
    return OptimizedMenuList;
}(React.Component));
exports.default = OptimizedMenuList;
//# sourceMappingURL=OptimizedMenuList.js.map